import { useEffect, useState, useCallback } from 'react';
import {
  readRecentDrawers,
  clearRecentDrawers,
  RECENT_DRAWERS_EVENT,
} from '@/utils/recentDrawers';

// useRecentDrawers — subscribes to the recent-drawers store and returns the live list.
export default function useRecentDrawers() {
  const [list, setList] = useState(() => readRecentDrawers());

  useEffect(() => {
    const sync = () => setList(readRecentDrawers());
    window.addEventListener(RECENT_DRAWERS_EVENT, sync);
    window.addEventListener('storage', sync); // cross-tab
    return () => {
      window.removeEventListener(RECENT_DRAWERS_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  const clear = useCallback(() => clearRecentDrawers(), []);
  return { list, clear };
}
